module.exports = __webpack_public_path__ + "img/18_002.5b325595.webp";